/* global d3 $ */
import { cluster, subset } from 'd3';
import { forOwn } from 'lodash';
import dataService from '../../service/dataService.js'
import pipeService from '../../service/pipeService.js';
import DrawSubsetView from './drawSubsetView.js'

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

export default {
    name: 'SubsetView',
    components: {
    },
    props: {
        mainViewData: {},
        selectedDataset: '', 
        selectedSplit: '', 
        filterStopWords: false, 

    },
    computed: {
    },
    data() {
        return {
            selected_cluster: [],
            hovered_cluster: [],
            cluster_num: 4,
            lassoed_data: [],
            containerId: "subsetViewContainer",
            loading: false,
            cluster_info: {
                'qc': [],
                'tc': [],
                'context_cpnet': []
            },
            loading_info: {
                'qc': false,
                'tc': false,
                'context_cpnet': false
            }
        }
    },
    watch: {
        mainViewData: function(mainViewData){
            
        },
        cluster_info: {
            handler: function (newvalue, oldVal) {
                //let new_cluster_stats = newvalue;
                //this.drawSubsetView.layout(new_cluster_stats);
            },
            deep: true
        },
        filterStopWords(newValue) {
            this.updateSubsetView();
        }, 
        loading_info:{
            handler: function (newvalue, oldVal) {
                let loading_pre_check = false;
                Object.keys(newvalue).forEach(d=>{
                    if(newvalue[d] == true){
                        loading_pre_check = true;
                    }
                })
                this.loading = loading_pre_check;
                if(this.loading == false){
                    this.updateSubsetView();
                }
            },
            deep: true
        },
        lassoed_data(newvalue){
            this.update_cluster_info();
        },
        cluster_num(newvalue){
            this.selected_cluster = [];
            //}
            pipeService.emitSelectSubsetData(this.lassoed_data);
            this.update_cluster_info();

            // cluster_num select event
            let target_info = {"view": "subset_view", "target": "cluster_num"}
            let additional_info = {"cluster_num": this.cluster_num}
            dataService.saveUserDataWrapper("select", target_info, additional_info);
            
        }
    },
    methods: {
        compute_links_in_cluster_info: function() {
            // Construct links between clusters data structure:
            for (const ctype of ['qc', 'tc']) {
                let id_to_index_mapping = {}
                for(let i = 0; i<this.cluster_info[ctype].length; i++){
                    let local_item = this.cluster_info[ctype][i];
                    id_to_index_mapping[local_item.id] = i;
                }
                

                for (const c of this.cluster_info[ctype]) {
                    // this.cluster_info[ctype] --> array
                    // c --> item
                    // console.log("Building links: ", ctype, c.id, c.id_list)
                    let links = []
                    for (const q_cluster of this.cluster_info['context_cpnet']) {
                        // console.log("Building links inside q_cluster: ", q_cluster.id, q_cluster.id_list)
                        links.push({
                            "source": c.id, 
                            "target": q_cluster.id,
                            "proportion": q_cluster.id_list.filter(id => c.id_list.includes(id)).length / c.id_list.length, 
                        })
                    }
                    let curr_index = id_to_index_mapping[c.id];
                    this.cluster_info[ctype][curr_index]['links'] = links
                    // console.log("Link data computed: ", this.cluster_info[ctype][c.id])
                }
            }
        },
        update_cluster_info: function(){
            //console.log("onSelect data Subset view ", data)
            //if(!isEmpty(_this.mainViewData)){
            // console.log("extracting clusters....")
            let data = this.lassoed_data;
            let idList = data.map((d) => d.index);
            let idListStr = JSON.stringify(idList);
            let cluster_num = ""+this.cluster_num;
            this.loading = true;
            //console.log("idListStr", idListStr)
            let key_list = ['qc', 'context_cpnet', 'tc']
            //let key_list = ['qc', 'context_cpnet', 'tc'];
            for (let i = 0; i < key_list.length; i++) {
                // console.log("fetching", key_list[i]);
                this.loading_info[key_list[i]] = true;
                dataService.subgroupCluster(this.selectedDataset, this.selectedSplit, 
                    idListStr, cluster_num, key_list[i], (cluster_stats) => {
                        this.loading_info[key_list[i]] = false;
                        console.log("data fetched", key_list[i], cluster_stats);
                        let cluster_info = Object.keys(cluster_stats).map(d=>{
                            return {"id": d, ...cluster_stats[d]}
                        })
                        this.cluster_info[key_list[i]] = cluster_info;
                });
            }
            
            
        },
        check_selected_cluster: function(selected_cluster, label, id){
            let checked = false;
            selected_cluster.forEach(d=>{
                if(d["id"] == id && d["label"] == label){
                    checked = true;
                }
            })
            return checked;
        },
        extract_subset_index: function(){
            let selected_cluster = this.selected_cluster;
            if(selected_cluster.length == 0){
                return this.lassoed_data;
            }else{
                let subset_data = selected_cluster[0].id_list.map(d=>{
                    return {"index":d}
                });
                return subset_data;
            }
        },
        compute_selected: function(){
            let key_mapping = [
                ["Question Concepts", "qc"],
                ["Question Stems", "context_cpnet"],
                ["Target Concepts", "tc"]
            ]
            let selected_cluster = this.selected_cluster;
            let hovered_cluster = this.hovered_cluster;
            for(let i = 0; i<key_mapping.length; i++){
                let label = key_mapping[i][0];
                let key = key_mapping[i][1];
                for(let j = 0; j<this.cluster_info[key].length; j++){
                    let local_cluster = this.cluster_info[key][j];
                    let id = local_cluster.id;
                    if(this.check_selected_cluster(selected_cluster, label, id)){
                        this.cluster_info[key][j]["selected"] = true;
                    }else{
                        this.cluster_info[key][j]["selected"] = false;
                    }
                    if(this.check_selected_cluster(hovered_cluster, label, id) ){
                        this.cluster_info[key][j]["hovered"] = true;
                        this.cluster_info[key][j]["hovered_links"] = true;
                    }else{
                        this.cluster_info[key][j]["hovered"] = false;
                        this.cluster_info[key][j]["hovered_links"] = false;
                        if(hovered_cluster.length == 0){
                            this.cluster_info[key][j]["hovered_links"] = true;
                        }
                    }
                }
            }
        },
        updateSubsetView: function(){
            this.compute_links_in_cluster_info();
            this.compute_selected();
            this.drawSubsetView.layout(this.cluster_info, this.filterStopWords);
        }

    },
    mounted: function() {
        const _this = this;
        _this.drawSubsetView = new DrawSubsetView(_this.containerId)
        if(!isEmpty(_this.mainViewData)){
            _this.drawMainView.layout(_this.mainViewData);
        }
        pipeService.onSelectData(data => {
            this.selected_cluster = [];
            this.lassoed_data = data;
            //}
            pipeService.emitSelectSubsetData(data);
        })
        pipeService.onSelectCluster(data => {
            this.selected_cluster = data;
            //}
            this.updateSubsetView();
            let subset_index = this.extract_subset_index();
            pipeService.emitSelectSubsetData(subset_index);
        })
        pipeService.onHoverCluster(data => {
            this.hovered_cluster = data;
            //}
            this.updateSubsetView();
        })
    },

}